import React from 'react'
import { BtnV2, Link, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { ConnectChannelModalSource } from 'common/core/constants/ChannelType'
import { useExploreModeConnectChannel } from 'common/core/hooks/useExploreModeConnectChannel'
import { IgExploreModeAnalytics } from 'common/core/lib/igExploreModeAnalytics'
import { getCurrentAccountChannelOfIntent } from 'common/core/selectors/currentAccountSelectors'
import { useIsIntercomFinAIEnabled } from 'utils/services/intercomFinAIAgent/useIntercomFinAIAgentWidget'

export const ExploreModeConnectInstagramNotification = () => {
  const channelOfIntent = useAppSelector(getCurrentAccountChannelOfIntent)
  const connectChannelModal = useExploreModeConnectChannel()
  const isIntercomFinAIEnabled = useIsIntercomFinAIEnabled()

  const handleConnect = () => {
    IgExploreModeAnalytics.logNotificationBarConnectClick()
    if (channelOfIntent) {
      connectChannelModal.open(
        [channelOfIntent],
        ConnectChannelModalSource.NOTIFICATION_BAR_DUMMY_MODE,
      )
    }
  }

  const handleChatWithUs = () => {
    IgExploreModeAnalytics.logNotificationBarChatWithUsClick()
  }

  return (
    <>
      <span>{l.translate('Connect Instagram to get started with Manychat')}</span>
      <BtnV2 variant="primary" onClick={handleConnect} className="m-l-sm">
        {l.translate('Connect')}
      </BtnV2>
      {isIntercomFinAIEnabled && (
        <Link
          as="button"
          className="fin-ai-trigger m-l-sm"
          contentColor="white"
          onClick={handleChatWithUs}
        >
          {l.translate('Chat with us')}
        </Link>
      )}
    </>
  )
}
